import { Checkbox, FormControlLabel, FormLabel, Grid, CircularProgress, ButtonGroup, Button } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { Multiselect, SecondaryButton } from '../../../../Core/FormInput';
import { MandatoryField } from '../../../../Core/FormInput/inputfields';
import CustomColorPicker from '../../../../Core/FormInput/CustomColorPicker';
import { getMADashboardGetDetailsByID, postMADashboard_AddUpdate, getMA_DAshboard_Dropdown } from '../../../../Core/Service/ManageAccount/manageAccountService';
import AppContext from '../../../../App/AppContext';

const AddEditDashboard = (props) => {
    const { showToast } = useContext(AppContext);
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState({
        mADashboardID: null,
        mADashboardName: '',
        mADashboardSequence: null,
        mADashboardHasBranch: false,
        mADashboardHasFranchise: false,
        mADashboardHasPeriod: false,
        mADashboardHasYear: false,
        mADashboardIsYTD: false,
        mADashboardBgColor: '#ffffff',
        mADashboardTextColor: '#000000',
        maDashboardDisplayDataLive: null,
        branchOptions: [],
        franchiseOptions: [],
        selectedBranches: [],
        selectedFranchises: [],
        isLoadingDropdowns: false,
        errors: {},
        mADashboardIsActive: false
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [dropdownRes, detailsRes] = await Promise.all([
                    getMA_DAshboard_Dropdown(),
                    props.selectedRowData?.maDashboardID ? getMADashboardGetDetailsByID(props.selectedRowData.maDashboardID) : Promise.resolve(null)
                ]);

                if (dropdownRes?.success) {
                    const branches =
                        dropdownRes.data.branches?.map((branch) => ({
                            id: +branch.branchCode,
                            name: branch.branchName
                        })) || [];

                    setState((st) => ({
                        ...st,
                        branchOptions: branches,
                        franchiseOptions: dropdownRes.data.franchiseRecords || [],
                        isLoadingDropdowns: false
                    }));

                    if (detailsRes?.success && detailsRes.data?.list?.length > 0) {
                        const dashboardData = detailsRes.data.list[0];
                        const selectedBranches = branches.filter((b) => detailsRes.data.defaultBranches.includes(b.id));
                        const selectedFranchises = (dropdownRes.data.franchiseRecords || []).filter((f) =>
                            detailsRes.data.defaultFranchise.includes(f.id.toString())
                        );

                        setState((st) => ({
                            ...st,
                            mADashboardID: dashboardData.maDashboardID,
                            mADashboardName: dashboardData.maDashboardName,
                            mADashboardSequence: dashboardData.maDashboardSequence,
                            mADashboardHasBranch: dashboardData.maDashboardHasBranch,
                            mADashboardHasFranchise: dashboardData.maDashboardHasFranchise,
                            mADashboardHasPeriod: dashboardData.maDashboardHasPeriod,
                            mADashboardHasYear: dashboardData.maDashboardHasYear,
                            mADashboardIsYTD: dashboardData.maDashboardIsYTD,
                            mADashboardBgColor: dashboardData.maDashboardBgColor,
                            mADashboardTextColor: dashboardData.maDashboardTextColor,
                            maDashboardDisplayDataLive: dashboardData.maDashboardDisplayDataLive,
                            mADashboardIsActive: dashboardData.maDashboardIsActive,
                            selectedBranches,
                            selectedFranchises
                        }));
                    }
                }
            } catch (error) {
                console.error('Error loading data:', error);
                showToast('Error loading dashboard data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [props.selectedRowData]);

    const inputChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const BranchChange = (e, selectedItems) => {
        setState((st) => ({
            ...st,
            selectedBranches: selectedItems
        }));
    };

    const FranchiseChange = (e, selectedItems) => {
        setState((st) => ({
            ...st,
            selectedFranchises: selectedItems
        }));
    };

    const validation = () => {
        let errors = {};
        let isValid = true;
        let errorMessages = [];

        if (!state.mADashboardName?.trim()) {
            isValid = false;
            errors.mADashboardName = 'Name is required';
            errorMessages.push('Name is required');
        }
        if (!state.mADashboardSequence || isNaN(state.mADashboardSequence) || state.mADashboardSequence < 1) {
            isValid = false;
            errors.mADashboardSequence = 'Sequence is required';
            errorMessages.push('Sequence is required');
        }

        setState((st) => ({ ...st, errors }));
        if (errorMessages.length > 0) {
            showToast(errorMessages.join(' | '));
        }
        return isValid;
    };

    const handleSubmitClick = async () => {
        if (validation()) {
            const data = {
                mADashboardID: state.mADashboardID,
                mADashboardName: state.mADashboardName.trim(),
                mADashboardSequence: Number(state.mADashboardSequence),
                mADashboardHasBranch: state.mADashboardHasBranch,
                mADashboardHasFranchise: state.mADashboardHasFranchise,
                mADashboardHasPeriod: state.mADashboardHasPeriod,
                mADashboardHasYear: state.mADashboardHasYear,
                mADashboardIsYTD: state.mADashboardIsYTD,
                mADashboardBgColor: state.mADashboardBgColor,
                mADashboardTextColor: state.mADashboardTextColor,
                maDashboardDisplayDataLive: state.maDashboardDisplayDataLive,
                defaultBranches: state.mADashboardHasBranch ? state.selectedBranches.map((b) => b.id) : [],
                defaultFranchise: state.selectedFranchises?.map((f) => f.id.toString()) || [],
                mADashboardIsActive: state.mADashboardIsActive
            };

            try {
                const res = await postMADashboard_AddUpdate(data);
                if (res.success) {
                    showToast('Dashboard saved successfully');
                    props.onClose(true);
                } else {
                    showToast(res.message || 'An error occurred');
                }
            } catch (error) {
                showToast('Error submitting dashboard');
            }
        }
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => ({
            ...st,
            [name]: checked,
            ...(!checked && {
                ...(name === 'mADashboardHasBranch' && { selectedBranches: [] }),
                ...(name === 'mADashboardHasFranchise' && { selectedFranchises: [] })
            })
        }));
    };

    const handleDisplayDataChange = (e) => {
        const { name } = e.target;
        setState((st) => ({
            ...st,
            maDashboardDisplayDataLive: name === 'displayDataLive'
        }));
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '310px' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MandatoryField
                        autoFocus
                        inputLabel="Name"
                        placeholder="Name"
                        value={state.mADashboardName}
                        onChange={inputChange}
                        name="mADashboardName"
                        errors={state.errors.mADashboardName}
                        inputProps={{ maxLength: 50 }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <MandatoryField
                        inputLabel="Sequence"
                        placeholder="Sequence"
                        type="number"
                        value={state.mADashboardSequence}
                        onChange={inputChange}
                        name="mADashboardSequence"
                        errors={state.errors.mADashboardName}
                        inputProps={{
                            onInput: (e) => {
                                if (e.target.value > 32767) e.target.value = 32767;
                                if (e.target.value < 1) e.target.value = '';
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <div style={{ paddingBottom: '25px' }}>
                        <FormLabel component="legend">Display YTD as default?</FormLabel>
                    </div>
                    <ButtonGroup color="primary">
                        <Button
                            variant={state.mADashboardIsYTD ? 'contained' : 'outlined'}
                            onClick={() => setState((st) => ({ ...st, mADashboardIsYTD: true }))}
                        >
                            Yes
                        </Button>
                        <Button
                            variant={state.mADashboardIsYTD ? 'outlined' : 'contained'}
                            onClick={() => setState((st) => ({ ...st, mADashboardIsYTD: false }))}
                        >
                            No
                        </Button>
                    </ButtonGroup>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormLabel component="legend">Filters</FormLabel>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item xs={2} sm={2} md={2} style={{ marginTop: '10px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={state.mADashboardHasBranch} onChange={handleCheckbox} name="mADashboardHasBranch" />
                                                }
                                                label="Branch"
                                            />
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={10}>
                                            <Multiselect
                                                options={state.branchOptions}
                                                value={state.selectedBranches}
                                                onChange={BranchChange}
                                                loading={state.isLoadingDropdowns}
                                                placeholder="Default Branches..."
                                                style={{ marginLeft: 25 }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Grid container direction="row" alignItems="center">
                                        <Grid item xs={2} sm={2} md={2} style={{ marginTop: '10px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={state.mADashboardHasFranchise}
                                                        onChange={handleCheckbox}
                                                        name="mADashboardHasFranchise"
                                                    />
                                                }
                                                label="Franchise"
                                            />
                                        </Grid>
                                        <Grid item xs={10} sm={10} md={10}>
                                            <Multiselect
                                                options={state.franchiseOptions}
                                                value={state.selectedFranchises}
                                                onChange={FranchiseChange}
                                                loading={state.isLoadingDropdowns}
                                                placeholder="Default Franchises..."
                                                style={{ marginLeft: 25 }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs="auto" style={{ marginTop: '10px' }}>
                                    <FormControlLabel
                                        control={<Checkbox checked={state.mADashboardHasPeriod} onChange={handleCheckbox} name="mADashboardHasPeriod" />}
                                        label="Period"
                                    />
                                </Grid>
                                <Grid item xs="auto" style={{ marginTop: '10px', marginLeft: 20 }}>
                                    <FormControlLabel
                                        control={<Checkbox checked={state.mADashboardHasYear} onChange={handleCheckbox} name="mADashboardHasYear" />}
                                        label="Year"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <FormLabel component="legend">Display Data?</FormLabel>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container direction="row" spacing={1} wrap="nowrap" alignItems="center">
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={state.maDashboardDisplayDataLive === true}
                                                        onChange={handleDisplayDataChange}
                                                        name="displayDataLive"
                                                    />
                                                }
                                                label="Live"
                                            />
                                        </Grid>
                                        <Grid item>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={state.maDashboardDisplayDataLive === false}
                                                        onChange={handleDisplayDataChange}
                                                        name="displayDataHistoric"
                                                        style={{ marginLeft: 33 }}
                                                    />
                                                }
                                                label="Historic"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <div style={{ paddingBottom: '25px' }}>
                                <FormLabel component="legend">Background Colour</FormLabel>
                            </div>
                            <CustomColorPicker
                                width="95%"
                                name="mADashboardBgColor"
                                id="mADashboardBgColor"
                                color={state.mADashboardBgColor}
                                onChange={(updatedColor) => setState((st) => ({ ...st, mADashboardBgColor: updatedColor.hex }))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <div style={{ paddingBottom: '25px' }}>
                                <FormLabel component="legend">Text Colour</FormLabel>
                            </div>
                            <CustomColorPicker
                                width="95%"
                                name="mADashboardTextColor"
                                id="mADashboardTextColor"
                                color={state.mADashboardTextColor}
                                onChange={(updatedColor) => setState((st) => ({ ...st, mADashboardTextColor: updatedColor.hex }))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <div style={{ paddingBottom: '25px' }}>
                                <FormLabel component="legend">Is Active?</FormLabel>
                            </div>
                            <ButtonGroup color="primary">
                                <Button
                                    variant={state.mADashboardIsActive ? 'contained' : 'outlined'}
                                    onClick={() => setState((st) => ({ ...st, mADashboardIsActive: true }))}
                                >
                                    Yes
                                </Button>
                                <Button
                                    variant={state.mADashboardIsActive ? 'outlined' : 'contained'}
                                    onClick={() => setState((st) => ({ ...st, mADashboardIsActive: false }))}
                                >
                                    No
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className="submit_btn">
                    <SecondaryButton fullWidth onClick={handleSubmitClick}>
                        Submit
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default AddEditDashboard;
